/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Spell Check Form" |
*
* @param {Spellcheck_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_form_label = /** @type {((inputs?: Spellcheck_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire de verification orthographique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechtschreibprüfungsformular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo di controllo ortografico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма проверки орфографии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de revisión ortográfica")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拼写检查表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スペルチェックフォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तनी जाँच प्रपत्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de verificação ortográfica")
	return /** @type {LocalizedString} */ ("Spell Check Form")
});